import { lang } from 'src/helpers';
import ERROR_CONST from '../helpers/lang/error';
import LANG_CONST from '../helpers/lang/const';

const errorDescriptions = (err) => {
  if (err?.status) {
    const msg = ERROR_CONST[err?.status];
    if (msg) {
      return lang.t(msg.title) + ': ' + lang.t(msg.description) + '\n' + lang.t(msg.suggestion);
    }
  }
  return typeof LANG_CONST.errors_obj[err] != 'undefined'
    ? lang.t(LANG_CONST.errors_obj[err])
    : lang.t('Error: ') + err;
};

export default errorDescriptions;
